module.exports = "'use strict';\nvar regexpExec = require('./_regexp-exec');\nrequire('./_export')({\n  target: 'RegExp',\n  proto: true,\n  forced: regexpExec !== /./.exec\n}, {\n  exec: regexpExec\n});\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/core-js/modules/es6.regexp.exec.js
// module id = 5h6t
// module chunks = 7